import { useParams } from "react-router-dom";
import Homepage from "../home";
import ProjectList from "./ProjectList";

export default function UatProjectPage() {
  const { projectId } = useParams<{ projectId: string }>();
  return <Homepage content={<ProjectList projectId={projectId} />} />;
}
